export const SET_PAGE = 'SET_PAGE';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';
export const SET_ANSWER = 'SET_ANSWER';
export const SET_MENU = 'SET_MENU';
export const RESET = 'RESET';
export const SHOW_MORE = 'SHOW_MORE';
